<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="card pb-5 my-5" style="width:100%">
          <div class="card-body">
            <div class="text-center mb-4">
              <img src="../assets/img/hokodo_logo_color.svg" alt="Hokodo" width="200" height="38.5">
            </div>
            <div class="text-center" v-if="success">
              <icon name="check-circle" class="feather-large"></icon>
              <h3 class="my-4">Your password has been changed</h3>
              <p class="pb-4">You will be redirected to login shortly.</p>
            </div>
            <form class="form-signin text-left" v-on:submit.prevent="confirmReset" v-else>
              <p class="mt-4 text-center">Please choose a new password for your account.</p>
              <div class="mb-3 invalid-feedback-password" v-if="error && !error.new_password">
                <p>Something went wrong while trying to reset your password.<br>Please <a class="link-underline" href="/#/reset">click here</a> to try again.</p>
              </div>
              <div class="form-group" @keyup.enter="confirmReset">
                <vue-password v-model="new_password"
                              id="inputPassword"
                              classes="input form-control"
                              placeholder="New Password"
                              :disableStrength="true">
                </vue-password>
                <div class="mb-3 invalid-feedback-password" v-if="error && error.new_password">
                  <p v-for="(description,index) in error.new_password" :key="index">{{description}}</p>
                </div>
              </div>
              <button class="btn btn-lg btn-primary btn-block" type="button" v-on:click="confirmReset" :disabled="loading"><icon name="settings" class="feather-spin" v-if="loading"></icon> Set New Password</button>
              <hr>
            </form>
          </div>
        </div>
      </div>
    </div>
    <hokodo-footer></hokodo-footer>
  </div>
</template>

<script>
import HokodoFooter from './partials/HokodoFooter'
import VuePassword from 'vue-password'
import auth from '../api/auth'

export default {
  data () {
    return {
      success: false,
      loading: false,
      error: null,
      new_password: null
    }
  },
  props: ['uid', 'token'],
  components: {
    HokodoFooter,
    VuePassword
  },
  mounted () {

  },
  methods: {
    confirmReset: function () {
      this.loading = true
      auth.confirmResetPassword({new_password: this.new_password, uid: this.uid, token: this.token},
        response => {
          this.success = true
          this.new_password = null
          var vm = this
          setTimeout(function () { vm.$router.push('/login') }, 3000)
        },
        error => {
          this.error = error
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmReset.vue